import React from 'react';
import { PhoneForwardedIcon, MessageCircleIcon, CalendarCheckIcon } from 'lucide-react';
export function AddOns() {
  const addOns = [{
    icon: PhoneForwardedIcon,
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    name: 'Live Transfer',
    price: 'AUD $99',
    setup: 'one-time setup',
    features: ['Instant Escalation for Time Sensitive Opportunities', 'Transfers With Full Caller Context', 'Smart Routing Based on Your Real Business Rules']
  }, {
    icon: MessageCircleIcon,
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80',
    name: 'FAQ Handling',
    price: 'AUD $299',
    setup: 'one-time fee',
    features: ['Turn AI agent into trained front-line knowledge assistant', 'Fenced responses using only approved information', 'Clear brand-safe responses', 'Faster resolution & reduced message volume']
  }, {
    icon: CalendarCheckIcon,
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&q=80',
    name: 'Appointment Booking',
    price: 'AUD $399',
    setup: 'one-time setup',
    features: ['Real-time calendar syncing (Google, Outlook, etc.)', 'Automated booking and confirmation', 'Custom booking rules', 'Caller notifications and internal alerts']
  }];
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36" data-id="element-48">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-49">
        <div className="text-center mb-20" data-id="element-50">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6 tracking-tight" data-id="element-51">
            Universal Add-Ons
          </h2>
          <p className="font-['Inter'] text-lg text-[#A0A0A0] max-w-3xl mx-auto font-light" data-id="element-52">
            Available for all plans to extend your AI answering service
            capabilities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-53">
          {addOns.map((addOn, index) => {
          const Icon = addOn.icon;
          return <div key={index} className="bg-[#252525] rounded-2xl overflow-hidden border border-[#2A2A2A] hover:border-[#F1B530]/30 transition-all duration-300 hover:-translate-y-1" data-id="element-54">
                {/* Feature Image */}
                <div className="relative h-48 overflow-hidden" data-id="element-55">
                  <img src={addOn.image} alt={addOn.name} className="w-full h-full object-cover opacity-60" data-id="element-56" />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#252525]" data-id="element-57"></div>
                  <div className="absolute bottom-4 left-4 w-14 h-14 bg-[#F1B530]/90 backdrop-blur-sm rounded-xl flex items-center justify-center border border-[#F1B530]" data-id="element-58">
                    <Icon className="w-7 h-7 text-[#0F0F0F]" data-id="element-59" />
                  </div>
                </div>

                <div className="p-10" data-id="element-60">
                  <h3 className="font-['Poppins'] font-bold text-2xl text-[#F5F5F5] mb-3" data-id="element-61">
                    {addOn.name}
                  </h3>

                  <div className="mb-8" data-id="element-62">
                    <span className="font-['Poppins'] font-semibold text-2xl text-[#F1B530]" data-id="element-63">
                      {addOn.price}
                    </span>
                    <span className="text-[#A0A0A0] font-['Inter'] text-sm ml-2" data-id="element-64">
                      {addOn.setup}
                    </span>
                  </div>

                  <ul className="space-y-4" data-id="element-65">
                    {addOn.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-66">
                        <span className="text-[#F1B530] mr-3 flex-shrink-0 text-lg" data-id="element-67">
                          •
                        </span>
                        <span className="font-['Inter'] text-[#F5F5F5] text-sm leading-relaxed font-light" data-id="element-68">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}